import { EventEmitter } from 'events';
export class TypedEventEmitter extends EventEmitter {
}
